var React = require('react');

function TransportationHubs (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1","data-name":"Layer 1"},React.createElement("path",{"d":"M8.8.21,0,9,8.8,17.79,17.59,9Zm0,11.64A2.85,2.85,0,1,1,11.65,9,2.86,2.86,0,0,1,8.8,11.85Z"})));
}

TransportationHubs.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = TransportationHubs;

TransportationHubs.default = TransportationHubs;
